import { useEffect, useRef, useState } from "react";
import Actions from "../../Actions/Creators";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { destroy } from "redux-form";
import RootLayout from "../../Components/shared/RootLayout";

import { scaleModerate } from "../../styles/responsive";
import Phi from "../../Phi/Phi";
import "./index.css";
import HSGStudentGrid from "../StudentContainer/Component/HSGStudentGrid/HSGStudentGrid.js";
import search from "../DashboardContainer/Component/NewUiimg/search.png";
import upar from "../DashboardContainer/Component/NewUiimg/upar.png";

const PAGE_SIZE = 6;

const customOrder = [
  "PLAYGROUP",
  "PRE-NURSERY",
  "NURSERY",
  "LKG",
  "UKG",
  "KG",
  "PREP",
  "I",
  "II",
  "III",
  "IV",
  "V",
  "VI",
  "VII",
  "VIII",
  "IX",
  "X",
  "XI",
  "XII",
];

const sortClassKeys = (classesObj = {}) => {
  return Object.keys(classesObj).sort((a, b) => {
    const cleanA = a.toString().trim().toUpperCase();
    const cleanB = b.toString().trim().toUpperCase();
    const indexA = customOrder.indexOf(cleanA);
    const indexB = customOrder.indexOf(cleanB);

    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;

    return cleanA.localeCompare(cleanB, undefined, {
      numeric: true,
      sensitivity: "base",
    });
  });
};

const InfirmaryNew = withRouter((props) => {
  const {
    studentList = [],
    totalStudent = 0,
    studentHeader = {},
    classes = {},
    fetchStudentList,
    organizationId,
    getSchoolClasses,
  } = props;

  const showAddEpisodeButton = props.roleType === 19 ? true : false;

  const startNodeId =
    Number(sessionStorage.getItem("latestInfirmaryProgramId")) || 11494;

  const [savedState] = useState(() =>
    JSON.parse(sessionStorage.getItem("studentListState") || "{}"),
  );
  const [inSearchString, setInSearchString] = useState(
    savedState.inSearchString || "",
  );
  const [selectedClass, setSelectedClass] = useState(
    Object.prototype.hasOwnProperty.call(savedState, "selectedClass")
      ? savedState.selectedClass
      : savedState.class || null,
  );
  const [selectedSection, setSelectedSection] = useState(
    Object.prototype.hasOwnProperty.call(savedState, "selectedSection")
      ? savedState.selectedSection
      : savedState.section || null,
  );
  const [selectedStatus, setSelectedStatus] = useState(
    Object.prototype.hasOwnProperty.call(savedState, "selectedStatus")
      ? savedState.selectedStatus
      : (savedState.isAssessed ?? null),
  );
  const [activeDropdown, setActiveDropdown] = useState(null);
  const hasActiveFilters =
    Boolean(inSearchString.trim()) ||
    selectedClass !== null ||
    selectedSection !== null ||
    selectedStatus !== null;

  const classDropdownRef = useRef(null);
  const sectionDropdownRef = useRef(null);
  const statusDropdownRef = useRef(null);

  useEffect(() => {
    if (organizationId && Object.keys(classes).length === 0) {
      getSchoolClasses(organizationId);
    }
  }, [organizationId, classes, getSchoolClasses]);

  useEffect(() => {
    if (!props.metaVitals?.length) props.fetchNurseMeta();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (activeDropdown) {
        const activeRefMap = {
          class: classDropdownRef,
          section: sectionDropdownRef,
          status: statusDropdownRef,
        };
        const currentRef = activeRefMap[activeDropdown];
        if (
          currentRef &&
          currentRef.current &&
          !currentRef.current.contains(event.target)
        ) {
          setActiveDropdown(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [activeDropdown]);

  useEffect(() => {
    if (!Number.isFinite(startNodeId) || startNodeId <= 0) return;

    const savedOffset = savedState.inOffset || 0;
    const savedSearch = savedState.inSearchString || "";
    const savedClass = savedState.class || "";
    const savedSection = savedState.section || "";
    const savedStatus = savedState.isAssessed ?? null;

    fetchStudentList({
      ...studentHeader,
      startNode: startNodeId,
      inOffset: savedOffset || 0,
      inLimit: PAGE_SIZE,
      inSearchString: savedSearch || "",
      class: savedClass || null,
      section: savedSection || null,
      isAssessed: savedStatus || null,
    });
  }, []);

  const triggerFetch = (overrides = {}) => {
    const searchValue =
      overrides.search !== undefined
        ? overrides.search
        : inSearchString.trim().toLowerCase();
    const classValue =
      overrides.class !== undefined ? overrides.class : selectedClass;
    const sectionValue =
      overrides.section !== undefined ? overrides.section : selectedSection;
    const statusValue =
      overrides.status !== undefined ? overrides.status : selectedStatus;

    sessionStorage.setItem(
      "studentListState",
      JSON.stringify({
        inOffset: 0,
        inSearchString: searchValue,
        class: classValue || "",
        section: sectionValue || "",
        isAssessed: statusValue,
        selectedClass: classValue,
        selectedSection: sectionValue,
        selectedStatus: statusValue,
      }),
    );

    fetchStudentList({
      ...studentHeader,
      startNode: startNodeId,
      inOffset: 0,
      inLimit: PAGE_SIZE,
      inSearchString: searchValue,
      class: classValue,
      section: sectionValue,
      isAssessed: statusValue,
    });
  };

  const refreshStudentList = () => {
    fetchStudentList({
      ...studentHeader,
      startNode: startNodeId,
      inOffset: studentHeader.inOffset || 0,
      inLimit: studentHeader.inLimit || PAGE_SIZE,
      inSearchString: inSearchString.trim().toLowerCase(),
      class: selectedClass,
      section: selectedSection,
      isAssessed: selectedStatus,
    });
  };

  const handlePagination = (where) => {
    const { inLimit = PAGE_SIZE, inOffset = 0 } = studentHeader || {};

    if (where === "prev") {
      const newOffset = Math.max(0, inOffset - inLimit);
      sessionStorage.setItem(
        "studentListState",
        JSON.stringify({
          inOffset: newOffset,
          inSearchString: inSearchString.trim().toLowerCase(),
          class: selectedClass || "",
          section: selectedSection || "",
          isAssessed: selectedStatus,
          selectedClass,
          selectedSection,
          selectedStatus,
        }),
      );
      fetchStudentList({
        ...studentHeader,
        startNode: startNodeId,
        inOffset: newOffset,
        inLimit,
        inSearchString: inSearchString.trim().toLowerCase(),
        class: selectedClass,
        section: selectedSection,
        isAssessed: selectedStatus,
      });
      return;
    }

    if (inOffset + inLimit >= totalStudent) return;

    const newOffset = inOffset + inLimit;
    sessionStorage.setItem(
      "studentListState",
      JSON.stringify({
        inOffset: newOffset,
        inSearchString: inSearchString.trim().toLowerCase(),
        class: selectedClass || "",
        section: selectedSection || "",
        isAssessed: selectedStatus,
        selectedClass,
        selectedSection,
        selectedStatus,
      }),
    );
    fetchStudentList({
      ...studentHeader,
      startNode: 11494 || startNodeId,
      inOffset: newOffset,
      inLimit,
      inSearchString: inSearchString.trim().toLowerCase(),
      class: selectedClass,
      section: selectedSection,
      isAssessed: selectedStatus,
    });
  };

  const handleSearchSubmit = (e) => {
    if (e.keyCode === 13) {
      triggerFetch({ search: inSearchString.trim().toLowerCase() });
    }
  };

  const handleSelectFilter = (field, val) => {
    setActiveDropdown(null);
    if (field === "selectedClass") {
      setSelectedClass(val);
      setSelectedSection(null);
      triggerFetch({ class: val, section: null });
    } else if (field === "selectedSection") {
      setSelectedSection(val);
      triggerFetch({ section: val });
    } else if (field === "selectedStatus") {
      setSelectedStatus(val);
      triggerFetch({ status: val });
    }
  };

  const handleResetFilter = () => {
    setSelectedClass(null);
    setSelectedSection(null);
    setSelectedStatus(null);
    setInSearchString("");
    setActiveDropdown(null);
    triggerFetch({
      search: "",
      class: null,
      section: null,
      status: null,
    });
  };

  const toggleDropdown = (name) => {
    setActiveDropdown((prev) => (prev === name ? null : name));
  };

  const renderSearchPanel = () => (
    <div
      style={{
        display: "inline-block",
        alignItems: "center",
        justifyContent: "flex-start",
        borderBottom: "2px solid #1E87F0",
        marginLeft: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "white",
          padding: "5px 10px 0px 0px",
          maxWidth: "350px",
          width: "100%",
        }}
      >
        <input
          onChange={(e) => setInSearchString(e.target.value)}
          onKeyDown={handleSearchSubmit}
          placeholder="Type in student name or HSG-ID.."
          type="text"
          value={inSearchString}
          style={{
            flexGrow: 1,
            border: "none",
            outline: "none",
            padding: "5px 0px",
            marginRight: "10px",
            backgroundColor: "white",
            width: "250px",
          }}
        />
        <img
          className="seachiconV2"
          src={search}
          alt="Search Icon"
          onClick={() =>
            triggerFetch({ search: inSearchString.trim().toLowerCase() })
          }
          style={{
            height: "20px",
            width: "20px",
            cursor: "pointer",
          }}
        />
      </div>
    </div>
  );

  const renderFilters = () => {
    const isClassOpen = activeDropdown === "class";
    const isSectionOpen = activeDropdown === "section";
    const isStatusOpen = activeDropdown === "status";

    const availableClasses = sortClassKeys(classes).filter(
      (c) => c !== selectedClass,
    );
    const availableSections =
      selectedClass && classes[selectedClass]
        ? classes[selectedClass].filter((s) => s !== selectedSection)
        : [];

    const statusOptions = [
      { label: "Assessed", key: true },
      { label: "Not Assessed", key: false },
    ];
    const availableStatuses = statusOptions.filter(
      (opt) => opt.key !== selectedStatus,
    );

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          flexWrap: "nowrap",
          gap: "14px",
          flexShrink: 0,
        }}
      >
        <button
          disabled={
            studentList.length === 0 &&
            !selectedClass &&
            !selectedSection &&
            selectedStatus === null &&
            !inSearchString
          }
          style={{
            border: "none",
            color: "#9B9B9B",
            background: "transparent",
            cursor: "pointer",
            whiteSpace: "nowrap",
            fontSize: "14px",
            fontWeight: 500,
            padding: "4px 8px",
          }}
          onClick={handleResetFilter}
        >
          RESET
        </button>

        <div
          ref={classDropdownRef}
          style={{
            position: "relative",
            display: "inline-block",
            flexShrink: 0,
          }}
        >
          <button
            type="button"
            onClick={() => toggleDropdown("class")}
            style={{
              background: "transparent",
              color: "#1E87F0",
              cursor: "pointer",
              border: "none",
              outline: "none",
              fontSize: "14px",
              fontWeight: 500,
              whiteSpace: "nowrap",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "4px 0",
              minWidth: "90px",
            }}
          >
            <span
              style={{
                maxWidth: "120px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {selectedClass || "CLASS"}
            </span>
            <img
              src={upar}
              style={{
                height: "16px",
                width: "16px",
                marginLeft: "8px",
                transform: isClassOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s ease",
              }}
              alt="Arrow"
            />
          </button>

          {isClassOpen && (
            <ul
              style={{
                position: "absolute",
                top: "calc(100% + 4px)",
                left: 0,
                backgroundColor: "#ffffff",
                zIndex: 1100,
                minWidth: "150px",
                maxHeight: "260px",
                overflowY: "auto",
                padding: "6px 0",
                margin: 0,
                listStyle: "none",
                borderRadius: "4px",
                border: "1px solid #E0E0E0",
                boxShadow: "0 6px 16px rgba(0, 0, 0, 0.12)",
              }}
            >
              {availableClasses.map((eachClass) => (
                <li key={eachClass} style={{ margin: 0, padding: 0 }}>
                  <button
                    type="button"
                    onClick={() =>
                      handleSelectFilter("selectedClass", eachClass)
                    }
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      textAlign: "left",
                      padding: "8px 16px",
                      fontSize: "13px",
                      background: "none",
                      border: "none",
                      display: "block",
                      color: "#333333",
                      outline: "none",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#F5F9FF")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    {eachClass}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div
          ref={sectionDropdownRef}
          style={{
            position: "relative",
            display: "inline-block",
            flexShrink: 0,
          }}
        >
          <button
            type="button"
            onClick={() => toggleDropdown("section")}
            style={{
              background: "transparent",
              color: "#1E87F0",
              cursor: "pointer",
              border: "none",
              outline: "none",
              fontSize: "14px",
              fontWeight: 500,
              whiteSpace: "nowrap",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "4px 0",
              minWidth: "90px",
            }}
          >
            <span
              style={{
                maxWidth: "120px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {selectedSection || "SECTION"}
            </span>
            <img
              src={upar}
              style={{
                height: "16px",
                width: "16px",
                marginLeft: "8px",
                transform: isSectionOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s ease",
              }}
              alt="Arrow"
            />
          </button>

          {isSectionOpen && (
            <ul
              style={{
                position: "absolute",
                top: "calc(100% + 4px)",
                left: 0,
                backgroundColor: "#ffffff",
                zIndex: 1100,
                minWidth: "140px",
                maxHeight: "260px",
                overflowY: "auto",
                padding: "6px 0",
                margin: 0,
                listStyle: "none",
                borderRadius: "4px",
                border: "1px solid #E0E0E0",
                boxShadow: "0 6px 16px rgba(0, 0, 0, 0.12)",
              }}
            >
              {selectedClass && availableSections.length ? (
                availableSections.map((section) => (
                  <li key={section} style={{ margin: 0, padding: 0 }}>
                    <button
                      type="button"
                      onClick={() =>
                        handleSelectFilter("selectedSection", section)
                      }
                      style={{
                        cursor: "pointer",
                        width: "100%",
                        textAlign: "left",
                        padding: "8px 16px",
                        fontSize: "13px",
                        background: "none",
                        border: "none",
                        display: "block",
                        color: "#333333",
                        outline: "none",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = "#F5F9FF")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = "transparent")
                      }
                    >
                      {section}
                    </button>
                  </li>
                ))
              ) : (
                <li
                  style={{
                    padding: "8px 16px",
                    fontSize: "13px",
                    color: "#999999",
                  }}
                >
                  {selectedClass ? "No other sections" : "Select class first"}
                </li>
              )}
            </ul>
          )}
        </div>

        {/* <div
          ref={statusDropdownRef}
          style={{
            position: "relative",
            display: "inline-block",
            flexShrink: 0,
          }}
        >
          <button
            type="button"
            onClick={() => toggleDropdown("status")}
            style={{
              background: "transparent",
              color: "#1E87F0",
              cursor: "pointer",
              border: "none",
              outline: "none",
              fontSize: "14px",
              fontWeight: 500,
              whiteSpace: "nowrap",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "4px 0",
              minWidth: "90px",
            }}
          >
            <span>
              {selectedStatus === null
                ? "STATUS"
                : selectedStatus
                  ? "Assessed"
                  : "Not Assessed"}
            </span>
            <img
              src={upar}
              style={{
                height: "16px",
                width: "16px",
                marginLeft: "8px",
                transform: isStatusOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s ease",
              }}
              alt="Arrow"
            />
          </button>

          {isStatusOpen && (
            <ul
              style={{
                position: "absolute",
                top: "calc(100% + 4px)",
                left: 0,
                backgroundColor: "#ffffff",
                zIndex: 1100,
                minWidth: "140px",
                padding: "6px 0",
                margin: 0,
                listStyle: "none",
                borderRadius: "4px",
                border: "1px solid #E0E0E0",
                boxShadow: "0 6px 16px rgba(0, 0, 0, 0.12)",
              }}
            >
              {availableStatuses.map((item) => (
                <li key={String(item?.key)} style={{ margin: 0, padding: 0 }}>
                  <button
                    type="button"
                    onClick={() =>
                      handleSelectFilter("selectedStatus", item.key)
                    }
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      textAlign: "left",
                      padding: "8px 16px",
                      fontSize: "13px",
                      background: "none",
                      border: "none",
                      display: "block",
                      color: "#333333",
                      outline: "none",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#F5F9FF")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div> */}
      </div>
    );
  };

  return (
    <RootLayout props={props}>
      <div style={styles.container}>
        <div style={styles.header}>
          <button
            onClick={() => props.history.push("/prev-episodes")}
            className="btn downloadReport actionsContainer"
            type="button"
            style={styles.button}
          >
            <p className="allonetxt" style={{ margin: 0 }}>
              ALL EPISODES
            </p>
          </button>
        </div>

        <div
          className="borderRadius"
          style={{
            display: "flex",
            backgroundColor: "white",
            paddingBottom: "2rem",
          }}
        >
          <div
            className="hsg-toolbar-group"
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "2rem 1rem",
              }}
            >
              {renderSearchPanel()}
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {renderFilters()}
              </div>
            </div>

            <div className="padding-left-1rem padding-right-1rem hsg-report-table">
              {props.isLoading ? (
                <div style={styles.emptyState} role="status">
                  Loading students...
                </div>
              ) : props.studentList?.length > 0 ? (
                <HSGStudentGrid
                  className="hsg-report-table"
                  offset={props.studentHeader?.inOffset || 0}
                  data={props.studentList}
                  total={props.totalStudent}
                  showNext={handlePagination}
                  inSearchString={inSearchString}
                  setSearchString={setInSearchString}
                  startNodeId={startNodeId}
                  setSelectedStudent={props.setSelectedStudent}
                  show={false}
                  showAddEpisodeButton={showAddEpisodeButton}
                  metaData={{ metaVitals: props.metaVitals || [] }}
                  initializeForm={props.initializeForm}
                  clearForm={props.clearForm}
                  postStudentEpisodeInfo={props.postStudentEpisodeInfo}
                  refreshStudentList={refreshStudentList}
                />
              ) : (
                <div style={styles.emptyState}>
                  <h3 style={styles.emptyStateTitle}>No students found</h3>
                  <p style={styles.emptyStateText}>
                    {hasActiveFilters
                      ? "No students match this search or filter."
                      : "There are no students available for this program."}
                  </p>
                  {hasActiveFilters && (
                    <button
                      type="button"
                      onClick={handleResetFilter}
                      style={styles.resetEmptyStateButton}
                    >
                      Clear search and filters
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </RootLayout>
  );
});

const mapStateToProps = (state) => {
  const userRole = Phi.User.roles();
  return {
    isLoading: state.auth.isLoading,
    organizationId: JSON.parse(Phi.Storage.getItem("organization"))
      ? JSON.parse(Phi.Storage.getItem("organization"))[0].org_id
      : null,
    studentHeader: state.student.studentHeader,
    studentList: state.student.studentList,
    totalStudent: state.student.totalStudent,
    startNodeMap: state.organization.startNodeMap,
    classes: state.organization.classes || {},
    roleType: userRole && userRole.length && userRole[0].role_type_id, // Assign roleType based on user roles
    metaVitals: state.organization.plusMetaVitals,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchStudentList: (payload) => dispatch(Actions.fetchStudentList(payload)),
  getSchoolClasses: (organizationId) =>
    dispatch(Actions.getSchoolClasses(organizationId)),
  setSelectedStudent: (payload) =>
    dispatch(Actions.setSelectedStudent(payload)),
  fetchNurseMeta: () => dispatch(Actions.fetchNurseMeta()),
  initializeForm: (data) => dispatch(Actions.initializeForm(data)),
  clearForm: () => dispatch(destroy("customForm")),
  postStudentEpisodeInfo: (studentId, customJson, episodeType) =>
    dispatch(
      Actions.postStudentEpisodeInfo(studentId, customJson, episodeType),
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(InfirmaryNew));

const styles = {
  container: {
    flex: 1,
    display: "flex",
    padding: scaleModerate(10),
    flexDirection: "column",
    gap: "20px",
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },

  button: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 0,
  },
  emptyState: {
    padding: "3rem 1rem",
    textAlign: "center",
    color: "#666666",
  },
  emptyStateTitle: {
    margin: 0,
    color: "#333333",
    fontSize: "1.5rem",
  },
  emptyStateText: {
    margin: "0.5rem 0 0",
  },
  resetEmptyStateButton: {
    marginTop: "1rem",
    padding: "0.5rem 0.75rem",
    color: "#1E87F0",
    backgroundColor: "white",
    border: "1px solid #1E87F0",
    borderRadius: "4px",
    cursor: "pointer",
  },
};
